import { render, staticRenderFns } from "./DeckTour.vue?vue&type=template&id=6c6d065c&scoped=true&"
import script from "./DeckTour.vue?vue&type=script&lang=ts&"
export * from "./DeckTour.vue?vue&type=script&lang=ts&"
import style0 from "./DeckTour.vue?vue&type=style&index=0&id=6c6d065c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d065c",
  null
  
)

export default component.exports